<template>
  <div>
    <va-card class="overflow-auto">
      <vue-element-loading :active="visible" :is-full-screen="true" />
      <div class="row">
        <div class="flex md6 sm6 xs12">
          <h4 class="card-title mx-2" style="font-size: 24px !important">
            DIGITAL GUIDE
          </h4>
        </div>
      </div>

      <b-input-group prepend="Search key" class="mt-3">
        <b-form-input
          v-model="keyword"
          placeholder="Please Enter Common Name or Scientific Name...."
        ></b-form-input>
        <b-input-group-append>
          <b-button variant="info">
            <i class="fa fa-search"></i>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <br />
      <h5>*Select the options to filter the results</h5>
      <div class="row">
        <div class="flex md3 sm6 xs12">
          <div class="form-group">
            <label
              for="exampleInputEmail1"
              style="text-align: left !important"
            ></label>
            <select
              class="pt-2 pb-2"
              style="width: 100% !important"
              v-model="classificationId"
            >
              <option class="text-capitalize" value selected disabled hidden>
                Classification
              </option>
              <option :value="null">All</option>
              <option v-for="cls in classi" :value="cls._id" :key="cls._id">
                {{ cls.cname }}
              </option>
            </select>
          </div>
        </div>
        <div class="flex md3 sm6 xs12">
          <div class="form-group">
            <label
              for="exampleInputEmail1"
              style="text-align: left !important"
            ></label>
            <select
              class="pt-2 pb-2"
              style="width: 100% !important"
              v-model="citesId"
            >
              <option value selected disabled hidden>CITES</option>
              <option :value="null">All</option>
              <option
                class="text-capitalize"
                v-for="cit in CITES"
                :value="cit._id"
                :key="cit._id"
              >
                {{ cit.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="flex md3 sm6 xs12">
          <div class="form-group">
            <label
              for="exampleInputEmail1"
              style="text-align: left !important"
            ></label>
            <select
              class="pt-2 pb-2"
              style="width: 100% !important"
              v-model="wlpaId"
            >
              <option value selected disabled hidden>WLPA</option>
              <option :value="null">All</option>
              <option
                class="text-capitalize"
                v-for="wlp in WLPA"
                :value="wlp._id"
                :key="wlp._id"
              >
                {{ wlp.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="flex md3 sm6 xs12">
          <div class="form-group">
            <label
              for="exampleInputEmail1"
              style="text-align: left !important"
            ></label>
            <select
              class="pt-2 pb-2"
              style="width: 100% !important"
              v-model="conservationStatusId"
            >
              <option value selected disabled hidden>IUCN</option>
              <option :value="null">All</option>
              <option
                class="text-capitalize"
                v-for="st in stat"
                :value="st._id"
                :key="st._id"
              >
                {{ st.csname }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="flex md12 sm6 xs12 overflow-auto">
        <div class="overflow-aut0" style="overflow: auto">
          <b-table
            hover
            v-if="data.length"
            class="table-sm th table-sm td"
            style="cursor: pointer"
            id="my-table"
            :fields="fields"
            :items="data"
            small
            @row-clicked="rowClicked"
            borderless
            head-variant="dark"
            table-variant="light"
          >
            <template v-slot:cell(sno)="data">
              <span v-if="currentPage > 1">{{
                (currentPage - 1) * perPage + data.item.sno
              }}</span>
              <span v-else>{{ data.item.sno }}</span>
            </template>
            <template v-slot:cell(photos[0])="data1" style="text-align: center">
              <img
                v-if="data1.item.photos.length"
                v-bind:src="baseURL + data1.item.photos[0]"
                width="50px"
                height="50px"
              />
              <img
                v-else
                src="../../assets/noimage.png"
                width="50px"
                height="50px"
              />
            </template>
            <template v-slot:cell(_id)="data">
              <span v-if="appUser.usertype == 0">
                <span style="padding-left: 20px !important">
                  <b-button variant="danger" @click="deleteCat(data.item._id)">
                    <i class="fa fa-trash"></i>
                  </b-button>
                </span>
              </span>
              <span v-else>
                <span style="padding-left: 20px !important">
                  <router-link :to="'/recordDetails/' + data.item._id">
                    <b-button variant="success"> View Details </b-button>
                  </router-link>
                </span>
              </span>
            </template>
            <template v-slot:cell(edit)="data">
              <span v-if="appUser.usertype == 0">
                <span style="padding-left: 20px !important">
                  <router-link :to="'/editRecords/' + data.item._id">
                    <b-button variant="info">
                      <i class="fa fa-edit"></i>
                    </b-button>
                  </router-link>
                </span>
              </span>
            </template>
            <template v-slot:cell(changeStatus)="data">
              <span v-if="appUser.usertype == 0">
                <span style="padding-left: 20px !important; color: white">
                  <b-button
                    v-if="data.item.status == 'active'"
                    variant="danger"
                    @click="confirmChangeStatus(data.item._id, 'inactive')"
                    ><i class="fa fa-close"></i
                  ></b-button>
                  <b-button
                    v-else
                    variant="info"
                    style="color: #ffffff"
                    @click="confirmChangeStatus(data.item._id, 'active')"
                    ><i class="fa fa-check"></i
                  ></b-button>
                </span>
              </span>
            </template>
          </b-table>
          <p v-else>No Data Found</p>
          <br />
          <b-pagination
            align="center"
            v-model="currentPage"
            :total-rows="totalData"
            :per-page="perPage"
            prev-text="Prev"
            next-text="Next"
            @change="nextPage"
            aria-controls="my-table"
          ></b-pagination>
          <br />
        </div>
      </div>
    </va-card>
  </div>
</template>

<script>
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'
export default {
  components: {
    VueElementLoading,
  },
  data () {
    return {
      id1: '',
      msg: '',
      visible: false,
      perPage: 50,
      currentPage: 1,
      dat: [],
      fields: [
        {
          key: 'sno',
          label: 'S.No',
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        {
          key: 'commonName',
          label: 'Common Name',
          tdClass: 'pdngtblcol1 ',
          thClass: ' pdngtblcol1',
        },
        {
          key: 'classificationId.cname',
          label: 'Classification',
          sortable: false,
          //  thClass:"pdngtblhead"
        },
        {
          key: 'citesId.name',
          label: 'CITES',
          sortable: false,
          //  thClass:"pdngtblhead"
        },
        {
          key: 'wlpaId.name',
          label: 'WLPA',
          sortable: false,
          //  thClass:"pdngtblhead"
        },
        {
          key: 'conservationStatusId.csname',
          label: 'IUCN',
          sortable: false,
          tdClass: 'pdngtblcol',
          // thClass:"pdngtblhead"
        },
        {
          key: 'status',
          label: 'Status',
          tdClass: 'text-capitalize',
          // thClass:"t"
        },
        {
          label: 'Images',
          key: 'photos[0]',
          sortable: false,
          // tdClass: 'tblpd',
        },

        {
          label: 'Update',
          key: 'edit',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Remove',
          key: '_id',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Enable/Disable',
          key: 'changeStatus',
          sortable: false,
          thClass: 'text-center',
          tdClass: '  text-center',
        },
      ],
      data: [],
      data1: [],
      occurenceId: '',
      wlpaId: '',
      classificationId: '',
      citesId: '',
      conservationStatusId: '',
      WLPA: [],
      CITES: [],
      stat: [],
      classi: [],
      keyword: '',
      totalData: '',
    }
  },

  mounted: function () {
    this.getList()
    this.wlpaview()
    this.statview()
    this.citesview()
    this.classview()
    // this.search();
  },

  computed: {
    rows () {
      return this.data.length
    },
    appUser () {
      if (this.$store.state.userData) return this.$store.state.userData
      else return {}
    },
  },

  watch: {
    classificationId: function () {
      this.getList()
    },
    conservationStatusId: function () {
      this.getList()
    },
    citesId: function () {
      this.getList()
    },
    wlpaId: function () {
      this.getList()
    },
    keyword: function () {
      this.search()
    },
  },

  methods: {
    rowClicked (item) {
      this.$router.push({ path: '/recordDetails/' + item._id })
    },
    nextPage (ev) {
      this.currentPage = ev
      this.getList()

      if (this.keyword) this.search()
    },
    deleteCat (val) {
      if (confirm('Are you sure?')) {
        this.visible = true
        axios({
          method: 'POST',

          headers: {
            token: localStorage.getItem('token'),
          },
          url: '/digitalguide/delete/' + val,
        })
          .then((response) => {
            this.visible = false
            if (response.data.status) {
              this.getList()
              this.msg = response.data.msg
              this.$dlg.alert(this.msg, () => {}, { messageType: 'success' })
            } else {
              this.msg = response.data.msg
              this.$dlg.alert(this.msg, () => {}, { messageType: 'error' })
            }
          })
          .catch((err) => {
            this.visible = false
            this.errors.push(err)
            this.$dlg.alert(
              this.msg,
              () => {
                // this.$router.push("/Dashboard");
              },
              { messageType: 'error' }
            )
          })
      } else {
        this.visible = false
        this.$router.push('/listRecords')
      }
    },
    statview () {
      // this.visible = true;;
      axios({
        method: 'POST',
        url: '/conservation/all/list',
      })
        .then((response) => {
          this.stat = response.data.data
          // this.visible = false;
        })
        .catch((err) => {
          // this.visible = false;
          console.log(err)
        })
    },
    classview () {
      // this.visible = true;;
      axios({
        method: 'POST',
        url: '/classification/all/list',
      })
        .then((response) => {
          this.classi = response.data.data

          // this.visible = false;
        })
        .catch((err) => {
          // this.visible = false;
          console.log(err)
        })
    },

    citesview () {
      // this.visible = true;;
      axios({
        method: 'POST',
        url: '/cites/all/list',
      })
        .then((response) => {
          this.CITES = response.data.data

          // this.visible = false;
        })
        .catch((err) => {
          // this.visible = false;
          console.log(err)
        })
    },
    wlpaview () {
      // this.visible = true;;
      axios({
        method: 'POST',
        url: '/wlpa/all/list',
      })
        .then((response) => {
          this.WLPA = response.data.data

          // this.visible = false;
        })
        .catch((err) => {
          // this.visible = false;
          console.log(err)
        })
    },

    getList () {
      this.visible = true
      var data1 = {}
      if (this.classificationId !== '') {
        data1['classificationId'] = this.classificationId
      }
      if (this.conservationStatusId !== '') {
        data1['conservationStatusId'] = this.conservationStatusId
      }
      if (this.citesId !== '') {
        data1['citesId'] = this.citesId
      }
      if (this.wlpaId !== '') {
        data1['wlpaId'] = this.wlpaId
      }
      data1['page'] = this.currentPage
      data1['limit'] = this.perPage
      data1['status'] = 'all'

      axios({
        method: 'POST',
        url: '/digitalguide/list',
        data: data1,
        headers: {
          token: localStorage.getItem('token'),
        },
      })
        .then((response) => {
          // for (var i = 0; i < this.data.length; i++) {
          //   var dt = this.data[i].create_date;
          //   dt = new Date(dt);
          //   dt = dt.toString();
          //   dt = dt.slice(0, 15);
          //   this.data[i].create_date = dt;

          // }
          for (var i = 0; i < response.data.data.length; i++) {
            response.data.data[i].sno = i + 1
          }
          if (response.data.status === true) {
            this.data = response.data.data
            this.totalData = response.data.totalLength

            this.visible = false
          } else if (response.data.status === false) {
            this.visible = false
          }
        })
        .catch((e) => {
          console.log(e)
          this.visible = false
          // this.errors.push(e)
          this.msg = 'failed'
        })
    },
    search () {
      this.visible = true
      var data1 = {}

      data1['keyword'] = this.keyword
      data1['page'] = this.currentPage
      data1['limit'] = this.perPage
      data1['status'] = 'all'

      axios({
        method: 'POST',
        url: '/digitalguide/search',
        data: data1,
        headers: {
          token: localStorage.getItem('token'),
        },
      })
        .then((response) => {
          // for (var i = 0; i < this.data.length; i++) {
          //   var dt = this.data[i].create_date;
          //   dt = new Date(dt);
          //   dt = dt.toString();
          //   dt = dt.slice(0, 15);
          //   this.data[i].create_date = dt;
          // }
          for (var i = 0; i < response.data.data.length; i++) {
            response.data.data[i].sno = i + 1
          }
          if (response.data.status === true) {
            this.data = response.data.data
            this.visible = false
          } else if (response.data.status === false) {
            this.visible = false
          }
        })
        .catch((e) => {
          console.log(e)
          this.visible = false
          // this.errors.push(e)
          this.msg = 'failed'
        })
    },
    confirmChangeStatus (id, status) {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to change the status ', {
          title: 'Please Confirm',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          cancelVariant: 'primary',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.changeStatus(id, status)
          }
        })
        .catch((err) => {
          // An error occurred
        })
    },
    changeStatus (id, status) {
      this.loading = true
      var data = {}
      data['status'] = status
      axios({
        method: 'POST',
        url: '/digitalguide/edit/' + id,
        data: data,
        headers: {
          token: localStorage.getItem('token'),
        },
      })
        .then((response) => {
          this.loading = false
          if (response.data.status) {
            this.getList()
          } else {
            alert(response.data.msg)
          }
        })
        .catch((err) => {
          this.loading = false
          this.errors.push(err)
        })
    },
  },
}
</script>
<style >
.pdngtblcol {
  padding-right: 50px !important;
}
.pdngtblcol1 {
  padding-left: 30px !important;
}

.pdngtblhead {
  padding-top: 30px !important;
  margin-top: 30px !important;
  padding-bottom: 30px !important;
}
.thead-dark {
  padding-top: 80px !important;
}

.filter {
  width: 100% !important;
}
.tblbutn {
  padding-bottom: 30px !important;
  text-align: right !important;
}

.rwd {
  width: 100px !important;
}
.bttwd {
  min-width: 220px !important;
}
.cnt {
  text-align: center;
}
</style>
